import { Injectable } from "@angular/core";
import { UserTerminal } from "../../models/user-terminal";
import { TokenService } from "./token.service";

@Injectable({
    providedIn: 'root',
})
export class UserTerminalService {
    readonly userTerminalKey = 'user_terminal';

    constructor(private tokenService: TokenService) {

    }

    addOrUpdateItem(userTerminal: UserTerminal) {
        var items = this.getItems();

        var userToUpdate = items.find(x => x.UserName == userTerminal.UserName);

        if (userToUpdate) {
            userToUpdate.TerminalCode = userTerminal.TerminalCode;
            this.saveInLocalStorage(items);
            return;
        }

        items.push(userTerminal);
        this.saveInLocalStorage(items);
    }

    getByLoggedUser() {
        var username = this.tokenService.getUsername();

        return this.getByUsername(username!);
    }

    getByUsername(username: string | null) {

        if (username == null) return null;

        var items = this.getItems();

        if (items.length == 0) return null;

        return items.find(x => x.UserName == username) ?? null;
    }

    private getItems() {
        var jsonString = localStorage.getItem(this.userTerminalKey);

        if (jsonString == null || jsonString == '') return [];

        const data: UserTerminal[] = JSON.parse(jsonString);

        return data;
    }

    private saveInLocalStorage(items: UserTerminal[]) {
        localStorage.removeItem(this.userTerminalKey);
        localStorage.setItem(this.userTerminalKey, JSON.stringify(items));
    }
}